import { Routes } from '@angular/router';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { DefaultLayoutComponent } from './layout';
import { AuthGuard } from './auth/auth.guard';
import { PermissionGuard } from './auth/permission.guard';
import { MasterAdminGuard } from './auth/master-admin.guard';
import { provideTranslocoScope } from '@jsverse/transloco';
import { preloadScope } from './i18n';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: marker('nav.home')
    },
    children: [
      {
        path: 'shops',
        canActivate: [AuthGuard, PermissionGuard],
        data: { title: marker('nav.shops'), requiredRolesAny: ['admin', 'superadmin', 'shops.management'] },
        providers: [provideTranslocoScope('shops')],
        resolve: { i18n: preloadScope('shops') },
        loadComponent: () => import('./views/shops/shops.component').then(m => m.ShopsComponent)
      },
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/home-page/routes').then((m) => m.routes).catch((err) => {
          console.error('Failed to load home-page/routes:', err);
          throw err;
        })
      },
      {
        path: 'sportbook',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['list.management', 'configuration']
        },
        loadChildren: () => import('./views/sportbook/routes').then((m) => m.routes)
      },
      {
        path: 'wallet',
        loadChildren: () => import('./views/wallet/routes').then((m) => m.routes)
      },
      {
        path: 'risk',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['risk']
        },
        loadChildren: () => import('./views/risk/routes').then((m) => m.routes)
      },
      {
        path: 'user-management',
        loadChildren: () => import('./views/user-management/routes').then((m) => m.routes)
      },
      {
        path: 'tenant-management',
        canActivate: [AuthGuard, MasterAdminGuard],
        data: {
          requiredRolesAny: ['superadmin']
        },
        loadChildren: () => import('./views/tenant-management/routes').then((m) => m.routes)
      },
      {
        path: 'analytics',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['crm']
        },
        loadChildren: () => import('./views/analytics/routes').then((m) => m.routes)
      },
      {
        path: 'crm',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['crm']
        },
        loadChildren: () => import('./views/crm/routes').then((m) => m.routes)
      },
      {
        path: 'web-app',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['appearance.management']
        },
        loadChildren: () => import('./views/web-app/routes').then((m) => m.routes)
      },
      {
        path: 'casino',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['casino.managment']
        },
        loadChildren: () => import('./views/casino/routes').then((m) => m.routes)
      },
      {
        path: 'gamification',
        canActivate: [PermissionGuard],
        data: {
          requiredRolesAny: ['admin', 'superadmin', 'configuration']
        },
        loadChildren: () => import('./views/gamification/routes').then((m) => m.routes)
      },
      {
        path: 'tickets',
        loadChildren: () => import('./views/tickets/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: marker('pages.notFound.title')
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: marker('pages.serverError.title')
    }
  },
  { path: '**', redirectTo: 'home' }
];
